import Route from '@ember/routing/route'

export default class BookingUpsellsRoute extends Route {}
